import Modal from './common/Modal';
import { Button } from '../utils/components/ui/button';

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  confirmColor?: string;
};

function ConfirmPopup({ open: isOpen, onConfirm, setOpen, title, message, confirmText, confirmColor }: Props) {
  return (
    <Modal open={isOpen} setOpen={setOpen}>
      <div className="p-4 min-w-[300px]">
        <h2 className="text-lg font-semibold mb-2">{title || "Delete a record"}</h2>
        <p className="mb-4">{message || "Are you sure you want to delete this record?"}</p>
        <div className="flex justify-end gap-2">
          <Button
            className="bg-gray-200 text-black"
            onClick={() => setOpen(false)}
            type="button"
          >
            Cancel
          </Button>
          <Button
            className={`${confirmColor || 'bg-[#1A5EF9]'} text-white`}
            onClick={() => {
              onConfirm();
              setOpen(false);
            }}
            type="button"
          >
            {confirmText || "Confirm"}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmPopup;
